import { render, staticRenderFns } from "./PlansBenchmark.vue?vue&type=template&id=482ba365&scoped=true"
import script from "./PlansBenchmark.vue?vue&type=script&lang=ts"
export * from "./PlansBenchmark.vue?vue&type=script&lang=ts"
import style0 from "./PlansBenchmark.vue?vue&type=style&index=0&id=482ba365&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ba365",
  null
  
)

export default component.exports